import { useMediaQuery } from "hooks/useMediaQuery"

/**
 * The desktop layout starts at 992px: the theme's static side menu
 * (layout-*.css), and list-and-map pages show their panes side by side. Below
 * it the menu is a drawer and those pages show one pane at a time under the
 * PaneBar. One width for both, so whoever sees the side menu sees list and map
 * together. Mirrors styles/_breakpoints.scss.
 */
export const DESKTOP_MIN_WIDTH_PX = 992

export const DESKTOP_QUERY = `(min-width: ${DESKTOP_MIN_WIDTH_PX}px)`

/** One pane at a time under the PaneBar. 991.98px, not 991px: with browser zoom
 *  the window can be 991.5px wide, which would match neither query. */
export const COMPACT_PANES_QUERY = `(max-width: ${DESKTOP_MIN_WIDTH_PX - 0.02}px)`

export const useCompactPanes = () => useMediaQuery(COMPACT_PANES_QUERY)

/** The first stretch of the desktop layout, where the map column beside the
 *  DV2 / RV2 list is narrow (~260–490px): panels that share it with the map
 *  (Activity / History) start collapsed. A default only, not a layout switch. */
export const NARROW_MAP_COLUMN_QUERY = "(max-width: 1199px)"

export const useNarrowMapColumn = () => useMediaQuery(NARROW_MAP_COLUMN_QUERY)
